/**
 * @namespace Utils
 * @aka COMMON.Utils
 *
 */
COMMON.Utils = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Private Helpers
   * ------------------------------------------------------------------------
   */

  var assetBaseURL = ('undefined' === typeof window.isFractal ? '' : '../..');
  if (window.location.host === 'localhost:8080') {
    assetBaseURL = '/cms';
  }

  // shoutout AngusCroll (https://goo.gl/pxwQGp)
  function toType(obj) {
    return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
  }

  function isElement(obj) {
    return (obj[0] || obj).nodeType;
  }

  var templateRe = /\{ *([\w_\-]+) *\}/g;

  var templateModalDialog = '<div class="modal modal-swr" tabindex="-1" role="dialog" id="{id}" aria-hidden="true">\n' +
    '<div class="modal-dialog">\n' +
    '<div class="modal-content">\n' +
    '{header}\n' +
    '{body}\n' +
    '{footer}\n' +
    '</div>\n' +
    '</div>\n' +
    '</div>';
  var templateModalHeader = '<div class="modal-header">\n' +
    '<h2 class="modal-title">{caption}</h2>\n' +
    '<button class="btn btn-close" type="button" aria-label="{caption} schließen" data-dismiss="modal">' +
    '<svg class="icon-close" focusable="false" aria-hidden="true" role="presentation">' +
    '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + ('undefined' === typeof window.isFractal ? (window.location.host === 'localhost:8080' ? '/cms' : '') : '../..') + '/assets/images/symbols.svg#close"></use>' +
    '</svg>' +
    '<span class="sr-only">{caption} schließen</span>' +
    '</button>\n' +
    '</div>';
  var templateModalBody = '<div class="modal-body">\n' +
    '{content}\n' +
    '</div>';
  var templateModalFooter = '<div class="modal-footer">\n' +
    '{content}\n' +
    '</div>';

  function getCanonical() {
    var canonical = '';
    var links = document.querySelectorAll('link[rel="canonical"]')
    for (var i = 0; i < links.length; i++) {
      if (links[i].hasAttribute('href')) {
        canonical = links[i].getAttribute('href')
      }
    }
    return canonical;
  }

  /**
   * --------------------------------------------------------------------------
   * Public Utils Api
   * --------------------------------------------------------------------------
   */

  var Utils = {
    assetBaseURL: assetBaseURL,
    getCanonical: getCanonical,

    /**
     * Checks if the `instance` is from the object `Constructor`
     * @param instance
     * @param Constructor
     * @private
     */
    _classCallCheck: function (instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    },

    _typeof: typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    },

    /**
     * Simple templating facility, accepts a template string of the form
     * `'Hello {a}, {b}'` and a data object like `{a: 'foo', b: 'bar'}`,
     * returns evaluated string `('Hello foo, bar')`. You can also
     * specify functions instead of strings for data values — they will
     * be evaluated passing `data` as an argument.
     *
     * @param {String} str
     * @param {Object} data
     * @returns {String}
     */
    template: function (str, data) {
      return str.replace(templateRe, function (str, key) {
        var value = data[key];

        if (value === undefined) {
          throw new Error('No value provided for variable ' + str);

        } else if (typeof value === 'function') {
          value = value(data);
        }
        return value;
      });
    },

    /**
     * This function creates a new anchor element and uses location
     * properties (inherent) to get the desired URL data. Some String
     * operations are used (to normalize results across browsers).
     *
     * @author James Padolsey <james@padolsey.net>
     * @copyright James Padolsey 2009
     * @see {@link http://james.padolsey.com/snippets/parsing-urls-with-the-dom/}
     *
     * @param {String} url
     * @type {Object}
     * @property {String} source
     * @property {String} protocol
     * @property {String} host
     * @property {String} port
     * @property {String} query
     * @property {Object.<String, String>} params
     * @property {String} file
     * @property {String} hash
     * @property {String} path
     * @property {String} relative
     * @property {Array} segments
     */
    parseUrl: function (url) {
      var a = document.createElement('a');
      a.href = url;
      return {
        source: url,
        protocol: a.protocol.replace(':', ''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function () {
          var ret = {},
            seg = a.search.replace(/^\?/, '').replace(/&amp;/g, "&").split('&'),
            len = seg.length,
            i = 0,
            s;
          for (; i < len; i++) {
            if (!seg[i]) {
              continue
            }
            s = seg[i].split('=');
            ret[s[0]] = s[1]
          }
          return ret
        })(),
        paramsAsArray: (function () {
          var segments = a.search.replace(/^\?/, '').replace(/&amp;/g, "&").split('&'),
            length = segments.length,
            segment,
            key,
            value,
            params = {};

          for (var i = 0; i < length; i++) {
            if (!segments[i]) {
              continue;
            }

            segment = segments[i].split('=');
            if (segment.length !== 2) {
              continue;
            }
            key = segment[0];
            value = segment[1];

            if (!params.hasOwnProperty(key)) {
              params[key] = [];
            }

            params[key].push(value);
          }

          return params;
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
        hash: a.hash.replace('#', ''),
        path: a.pathname.replace(/^([^\/])/, '/$1'),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
        segments: a.pathname.replace(/^\//, '').split('/')
      };
    },

    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (configTypes.hasOwnProperty(property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ': ' + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
          }
        }
      }
    },

    getScriptOnce: (function () {
      var urlState = {};

      return function (url, success) {
        if ("undefined" == typeof urlState[url]) {
          init(url, success);
        } else {
          // init(url, success);
          urlState[url](url, success);
        }
      };

      function init(url, success) {
        urlState[url] = loading;
        $.ajax({ // $.getScript has no option to disable CacheBuster
          url: url,
          dataType: "script",
          cache: true,
          success: function () {
            urlState[url] = loaded;
            if (success) {
              success();
            }
          }
        });
      }

      function loading(url, success) {
        // while url is being loaded, do not do anything,
        // success will be called anyway after loading completes
      }

      function loaded(url, success) {
        if (success) {
          success();
        }
      }

    })(),

    getScript: (function () {
      return function (url, success) {
        //$.getScript(url, success);
        $.ajax({ // $.getScript has no option to disable CacheBuster
          url: url,
          dataType: "script",
          cache: false,
          success: function () {
            if (success) {
              success();
            }
          }
        });
      };

    })(),

    addStylesheetOnce: function (href) {
      if ($('link[rel=stylesheet][href="' + href + '"]').length <= 0) {
        $('<link rel="stylesheet" href="' + href + '"/>').appendTo(document.head);
      }
    },

    loadScript: function loadScript(id, src, callback) {
      var js;
      if (document.getElementById(id)) {
        if (typeof callback === 'function') {
          callback()
        }
        return;
      }
      js = document.createElement('script');
      js.id = id;
      js.src = src;
      js.async = false;
      if (typeof callback === 'function') {
        js.onload = callback;
      }
      document.body.appendChild(js);
    },

    loadCss: function loadCss(id, src, callback) {
      var link;
      var flink = document.getElementsByTagName('link')[0];
      if (document.getElementById(id)) {
        if (typeof callback === 'function') {
          callback()
        }
        return;
      }
      link = document.createElement('link');
      link.id = id;
      link.href = src;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      if (typeof callback === 'function') {
        link.onload = callback;
      }
      flink.parentNode.insertBefore(link, flink);
    },

    uuid: function uuid() {
      return Array.apply(null, {length: 36}).map(function (_, i) {
        if (8 === i || 13 === i || 18 === i || 23 === i) {
          return "-";
        } else if (14 === i) {
          return "4";
        } else if (19 === i) {
          return (Math.floor(Math.random() * 4) + 8).toString(16);
        } else {
          return Math.floor(Math.random() * 15).toString(16);
        }
      }).join("");
    },

    modalDialog: function (id, header, body, footer) {
      if (!footer)
        footer = '';

      var $header = $(header);
      if (0 !== $header.find('.modal-title').length) {
        $header.find('.modal-title').attr('id', id + '-modal-title');
        header = $header.outerHTML();

        var $templateModalDialog = $(templateModalDialog);
        $templateModalDialog.attr('aria-labelledby', id + '-modal-title');
        templateModalDialog = $templateModalDialog.outerHTML();
      }

      return COMMON.Utils.template(templateModalDialog, {
        id: id,
        header: header,
        body: body,
        footer: footer
      })
    },

    modalHeader: function (caption) {
      return COMMON.Utils.template(templateModalHeader, {
        caption: caption
      })
    },

    modalBody: function (content) {
      return COMMON.Utils.template(templateModalBody, {
        content: content
      })
    },

    modalFooter: function (content) {
      return COMMON.Utils.template(templateModalFooter, {
        content: content
      })
    },

    /*****
     * Liefert das Portal mit allen zugehörigen Artikeln/Präpositionen
     * Index  Inhalt
     * 0      Artikel (Nominativ)
     * 1      Portalname
     * 2      Artikel (Genitiv)
     * 3      Artikel (Dativ)
     * 4      Artikel (Akkusativ)
     * 5      Präposition
     * 6      Präposition + Artikel
     * @return {string[]}
     */
    getPortal: function getPortal() {
      var hostArray = window.location.hostname.split('.');
      var host = null;
      var portalswitcher = getCookie("portalswitcher");

      for (var i = 0; i < hostArray.length; i++) {
        if (hostArray[i].match(/swr3|dasding|kindernetz|planet-schule|swrfernsehen|herzenssache|swr/g)) {
          host = hostArray[i];
          break;
        }
      }

      switch (host) {
        case "swr3": return ["", "SWR3", "", "", "", "Von ", "Von "];
        case "dasding": return ["", "DASDING", "", "", "", "Von ", "Von "];
        case "kindernetz": return ["Das ", "Kindernetz", "Des ", "Dem ", "Das ", "Von ", "Vom "];
        case "planet-schule": return ["", "planet schule", "", "", "", "Von ", "Von "];
        case "swrfernsehen": return ["Der ", "SWR", "Des ", "Dem ", "Den ", "Von ", "Vom "];
        case "herzenssache": return ["Der ", "SWR", "Des ", "Dem ", "Den ", "Von ", "Vom "];
        case "swr": return ["Der ", "SWR", "Des ", "Dem ", "Den ", "Von ", "Vom "];
      }

      //Wenn wir uns auf der Vorschau befinden:
      if (window.location.pathname.indexOf("/swr3/") > -1 || portalswitcher === "swr3") {
        return ["", "SWR3", "", "", "", "Von ", "Von "];
      } else if (window.location.pathname.indexOf("/dasding/") > -1 || portalswitcher === "dasding") {
        return ["", "DASDING", "", "", "", "Von ", "Von "];
      } else if (window.location.pathname.indexOf("/kindernetz/") > -1 || portalswitcher === "kindernetz") {
        return ["Das ", "Kindernetz", "Des ", "Dem ", "Das ", "Von ", "Vom "];
      } else if (window.location.pathname.indexOf("/planet-schule/") > -1 || portalswitcher === "planet") {
        return ["", "planet schule", "", "", "", "Von ", "Von "];
      } else {
        return ["Der ", "SWR", "Des ", "Dem ", "Den ", "Von ", "Vom "];
      }
    },

    hashCode: function hashCode(string) {
      let hash = 0;

      for (let i = 0; i < string.length; i++) {
        hash = Math.imul(31, hash) + string.charCodeAt(i) | 0;
      }

      return hash;
    }
  };

  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  return Utils;

}(window.jQuery);
